// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OT7mK","products":"_2nGjc","breadcrumbsNavigation":"_2hLR4","suggestions":"s0wke","blockImg":"_158Ef","image":"_9gsXc","title":"b7SEd"};